import { JSONSchemaType } from 'ajv'

export interface IRequestPermissionFormData {
  cadastraisDosTitulastes: boolean
  cadastraisDosDependentes: boolean
  informacoesDaEmpresa: boolean
  contratosDeTrabalhosDosTitulares: boolean
  historicoDeDadosCadastrais: boolean
  historicoDeAfastamentos: boolean
  historicoDeContratosDeTrabalho: boolean
  informacoesDaFolha: boolean
}

const RequestPermissionSchema: JSONSchemaType<IRequestPermissionFormData> = {
  type: 'object',
  properties: {
    cadastraisDosTitulastes: {
      type: 'boolean',
      default: true,
    },
    cadastraisDosDependentes: {
      type: 'boolean',
      default: false,
    },
    informacoesDaEmpresa: {
      type: 'boolean',
      default: false,
    },
    contratosDeTrabalhosDosTitulares: {
      type: 'boolean',
      default: false,
    },
    historicoDeDadosCadastrais: {
      type: 'boolean',
      default: false,
    },
    historicoDeAfastamentos: {
      type: 'boolean',
      default: false,
    },
    historicoDeContratosDeTrabalho: {
      type: 'boolean',
      default: false,
    },
    informacoesDaFolha: {
      type: 'boolean',
      default: false,
    },
  },
  required: [],
  additionalProperties: false,
}

export default RequestPermissionSchema
